var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-banner'),_vm._v(" "),_c('v-productCharacteristic'),_vm._v(" "),_c('v-setMeal'),_vm._v(" "),_c('v-equipment'),_vm._v(" "),_c('v-intro'),_vm._v(" "),_c('v-productmeal'),_vm._v(" "),_c('v-footpannel')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler?{"id":"data-v-c0bd6ee4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/home/home.vue
// module id = null
// module chunks = 